export default __webpack_public_path__ + "static/media/18_AllOfMe.23022be7.mp3";